<div class="header-wrapper">
  <div class="image" *ngIf="profileUrl">
    <elements-image-round-smart size="110px" [imageUrl]="profileUrl" imageFallbackUrl="/assets/default-avatar.png">
    </elements-image-round-smart>
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
